import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import Private from './Private'
import SurveyAndEvaluations from 'components/evaluations'

export default function SurveyEvaluations() {
  const { t } = useTranslation()
  return (
    <Private>
      <Helmet>
        <title>Koç Office Free - {t('profile.menu-items.evaluation')}</title>
        <meta
          name="description"
          content="Office Free ile ister şirketinden, ister Koç Topluluğu ortak ofislerinden çalışma planı gerçekleştirebilir, istersen de uzaktan çalışma bildirimi yapabilirsin."
        />
      </Helmet>

      <SurveyAndEvaluations />
    </Private>
  )
}
